import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/learning-center")({
  beforeLoad: () => {
    throw redirect({ to: "/insights/learning-centre", statusCode: 301 });
  },
});
